<div class="dialog-frame">
  <h2 mat-dialog-title class="title">{{ "iplexDeviceStartConnectDialogComponent.switchToOfflineConfirmationTitle" | translate }}</h2>

  <mat-dialog-content class="mat-typography guidance-message-content message-content">
    <p>{{ "iplexDeviceStartConnectDialogComponent.switchToOfflineConfirmationMessage1" | translate }}</p>
    <p>{{ "iplexDeviceStartConnectDialogComponent.switchToOfflineConfirmationMessage2" | translate }}</p>
  </mat-dialog-content>

  <mat-dialog-actions>
    <button mat-button mat-dialog-close color="primary">{{ "iplexDeviceStartConnectDialogComponent.cancelSwitchToOffline" | translate }}</button>
    <button mat-button color="primary" (click)="confirm()">{{ "iplexDeviceStartConnectDialogComponent.confirmSwitchToOffline" | translate }}</button>
  </mat-dialog-actions>
</div>
